import { httpApi } from '@api/http.api';
import type {
    CommonTablePaginatedResponse,
    CommonTableRequest,
} from '@routes/sidebar/admin-center/___shared___/types.ts';

export type TradingAreasRequest = CommonTableRequest;

export interface TradingArea {
    id: number;
    tradingAreaName: string | null;
    restrictionNotes: string | null;
    isActive: boolean;
    isBuiltIn: boolean;
    createdAtUTC: string;
}

export interface ResultsDescription {
    [k: string]: unknown;
}

export interface TradingAreaResponse {
    data: TradingArea[];
    pagination: CommonTablePaginatedResponse;
    resultsDescription: ResultsDescription;
}

export interface CreateTradingAreaRequest {
    tradingAreaName: string;
    restrictionNotes: string;
}

export type UpdateTradingAreaRequest = CreateTradingAreaRequest;

export const getApiTradingAreas = (
    clientId: number,
    tenantAlias: string,
    payload: TradingAreasRequest,
): Promise<TradingAreaResponse> =>
    httpApi
        .post<TradingAreaResponse>(
            `admin-center/clients/${clientId}/tenants/${tenantAlias}/trading-areas/search`,
            payload,
        )
        .then(({ data }) => data);

export const createApiTradingArea = (
    clientId: number,
    tenantAlias: string,
    payload: CreateTradingAreaRequest,
): Promise<TradingArea> =>
    httpApi
        .post<TradingArea>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/trading-areas`, payload)
        .then(({ data }) => data);

export const updateApiTradingArea = (
    clientId: number,
    tenantAlias: string,
    id: number,
    payload: UpdateTradingAreaRequest,
): Promise<TradingArea> =>
    httpApi
        .put<TradingArea>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/trading-areas/${id}`, payload)
        .then(({ data }) => data);
